import React from "react";
import {
  Pagination,
  PaginationProps,
} from "@campgladiator/cgui-core.atoms.pagination";
import styles from "./table-footer.module.scss";

type TableFooterProps = {
  currentPage: number;
  onPageChange: (page: number) => void;
  size?: PaginationProps["size"];
  totalPageCount: number;
};

const TableFooter = ({
  currentPage,
  onPageChange,
  size,
  totalPageCount,
}: TableFooterProps) => (
  <footer className={styles.footer}>
    <Pagination
      onPageChange={onPageChange}
      totalCount={totalPageCount}
      currentPage={currentPage}
      size={size}
    />
  </footer>
);

export default TableFooter;
